import { CustomEdge, EdgeModel } from '../../types';
import { ItemType } from '../../constants';
import { deleteUtils } from '../utils';
import { edgeConfigOptions } from './edgeStyles';

export const edgeConfig: CustomEdge = {
  options: edgeConfigOptions,

  afterDraw(model, group) {
    if (!group) return;

    const options = this.getOptions(model);

    if (deleteUtils.isEnabled(model as EdgeModel)) {
      deleteUtils.draw({ options, group, model: model as EdgeModel, type: ItemType.Edge });
      deleteUtils.updateVisibility({ group, isVisible: false });
    }

    group.sort();
  },

  afterUpdate(model, item) {
    if (!item) return;

    const group = item?.getContainer();
    const options = this.getOptions(model);

    if (deleteUtils.isEnabled(model as EdgeModel)) {
      deleteUtils.updatePosition({
        options,
        group,
        model: model as EdgeModel,
        type: ItemType.Edge,
      });
      deleteUtils.updateVisibility({ group, isVisible: false });
    }
  },
};
